import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { Box } from '@mui/material'
import TabButtonGroup from './tabButtonGroup'

export const Wrapper = styled(Box)(`
    position:relative;
    height: 35px;
    border: 1px #D8D8D6 solid;
    border-radius: 4px;
    margin-left: 10px;
    padding: 0 6px;
    display: flex;
    justify-content: center;
    align-items: center;

    & div {
        box-shadow: none !important;
    }

    & button {
        font-weight: 400;
        font-size: 14px;
        padding: 6px;
        min-width: 20px !important;
        border:0 !important;
        background: transparent !important;
        color: #095BBD;
        line-height:1;
    }
    & button.MuiButton-colorInherit {
        color: #686867;
    }
`)

const ProgressionRange = ({
  defaultSelected,
  data,
  progressionRangeObject,
  setProgressionRangeObject,
}) => {
  const handleSelection = (selectedKey) => {
    setProgressionRangeObject(selectedKey)
  }

  useEffect(() => {
    if (defaultSelected?.title && !progressionRangeObject?.title) {
      setProgressionRangeObject(defaultSelected)
    } else if (!progressionRangeObject?.title) {
      setProgressionRangeObject(data[0])
    }
  }, [data])

  return (
    <Wrapper className='graphBtns'>
      {data?.length && progressionRangeObject?.title && (
        <TabButtonGroup
          options={data}
          onSelect={handleSelection}
          defaultSelected={defaultSelected?.title || progressionRangeObject?.title}
        />
      )}
    </Wrapper>
  )
}

export default React.memo(ProgressionRange)
